export default __webpack_public_path__ + "static/media/Background_00015.0f47e52a.png";